import { EntityFileModel } from "./entity-file-model";
import { FileRequestModel } from "./file-request-model";

export class OCRUploadEntityFileRequestModel {
    sourceOCREntityFileRequest!: FileRequestModel;
    targetEntityFileUpload!: EntityFileModel;
}